export default "__VITE_ASSET__Ykz8m7j2__"